import * as React from 'react';
import * as styles from './TermCheckbox.css';
import { IATreeview } from '../treeview/Treeview';
import { ITreeViewItem } from '../../interfaces/ITreeViewItem';
import CategoryService from '../../services/CategoryService';
import { IInstance } from '../../interfaces/IInstance';
import { IATooltip } from '../tooltip/Tooltip';
import { IAIcon } from '../icon/Icon';

export interface ITermCheckboxProps {
  label?: string;
  token: string;
  tenant?: string;
  instance?: IInstance;
  environment?: "Development" | "Test" | "Production",
  component?: string;
  hideCheckbox?: boolean;
  categoryDataItems?: string;
  selectedValues?: any[];
  highlightColor: string;
  required?: boolean;
  toolTip?: string;
  onChange: (selectedNodes: any[]) => void;
  isIE?: boolean;
  useColors?: boolean;
}

export interface ITermCheckboxState {
  availableCategoriesForComponent?: any[];
}

export class IATermCheckbox extends React.Component<ITermCheckboxProps, ITermCheckboxState> {

  private selectedCategories?: any[];

  public constructor(props: ITermCheckboxProps) {
    super(props);
    this.state = {
    };
  }

  public componentDidMount(): void {
    this.loadCategories();
  }

  private childrenCategoriesAreChecked(category: any, id: string): void {
    if (category.children) {
      category.children.forEach((child: any) => {
        if (id === child.guid) {
          child.checked = true;
        }
        this.childrenCategoriesAreChecked(child, id);
      });
    }
  }

  private loadCategories(): void {

    this.setState({ availableCategoriesForComponent: [] });
    if (this.props.categoryDataItems) {
      const tempCategories = JSON.parse(this.props.categoryDataItems);
      console.log("tempCategories");
      console.log(tempCategories);
      if (this.props.selectedValues) {
        this.props.selectedValues.forEach((selectedCategory: any) => {
          tempCategories.forEach((category: any) => {
            if (selectedCategory.id === category.guid) {
              category.checked = true;
            }
            this.childrenCategoriesAreChecked(category, selectedCategory.id);
          });
        });
      }
      this.setState({
        availableCategoriesForComponent: tempCategories
      });
    } else {
      if (this.props.environment && this.props.instance && this.props.tenant && this.props.token && this.props.component) {
        console.log("categories");
        CategoryService.getCategories(this.props.environment, this.props.instance.instanceName, this.props.tenant, this.props.token, this.props.component === "Messages" ? "IntraActive-Messages" : "IntraActive-Events", this.props.component).then((result) => {
          if (result && result[0] && result[0].data) {
            if (this.props.selectedValues) {
              this.props.selectedValues.forEach((selectedCategory: any) => {
                result[0].data.items.forEach((category: any) => {
                  if (selectedCategory.id === category.guid) {
                    category.checked = true;
                  }
                  this.childrenCategoriesAreChecked(category, selectedCategory.id);
                });
              });
            }
            console.log("result");
            console.log(result);
            this.setState({
              availableCategoriesForComponent: result[0].data.items
            });
          }
        });
      }
    }
  }

  private hasSelectedChild(item: ITreeViewItem): void {
    item.children?.forEach((child: ITreeViewItem) => {
      if (child.checked) {
        var colors = this.props.useColors ? { bgColor: child.bgColor, textColor: child.textColor } : {}
        this.selectedCategories.push(
          {
            id: child.guid,
            name: child.name,
            ...colors
          }
        );
      }
      this.hasSelectedChild(child);
    });
  }

  public render() {
    let label = <div style={{ float: "left" }}>{this.props.label}</div>;
    if (this.props.required) {
      label = <div style={{ float: "left" }}>{this.props.label} <span style={{ color: "red" }}>*</span></div>;
    }
    return (
      <div
        className={styles.panelGrid}
      >
        <div>
          {label}
          {this.props.toolTip && this.props.toolTip !== "" &&
            <IATooltip
              content="Tooltip"
              type={window.innerWidth < 667 ? "popup" : "bubble"}
              styles={{
                textAlign: "left",
                color: "#333333"
              }}
              componentContent={
                <div>
                  {this.props.toolTip}
                </div>
              }
            >
              <IAIcon
                title="Info"
                size={14}
                color={this.props.highlightColor !== undefined ? this.props.highlightColor : "#03787c"}
                style={{
                  float: "left",
                  cursor: "pointor",
                  marginLeft: 4,
                  marginTop: 2,
                  height: 13
                }}
              />
            </IATooltip>
          }
          <div style={{ clear: "both" }}>
            <IATreeview
              highlightColor={this.props.highlightColor}
              actionType={this.props.hideCheckbox ? undefined : "Checkbox"}
              expanded={false}
              structureType="Arrow"
              onChange={(items: ITreeViewItem[]) => {
                this.selectedCategories = [];
                this.setState({ availableCategoriesForComponent: items }, () => {
                  items.forEach((item: ITreeViewItem) => {
                    if (item.checked) {
                      var colors = this.props.useColors ? { bgColor: item.bgColor, textColor: item.textColor } : {}
                      this.selectedCategories.push({
                        id: item.guid,
                        name: item.name,
                        ...colors
                      });
                    }
                    this.hasSelectedChild(item);
                  });
                  // Clean array
                  const uniqueItems: ITreeViewItem[] = [];
                  this.selectedCategories?.forEach((item: ITreeViewItem) => {
                    let addedAlready = false;
                    uniqueItems?.forEach((alreadyAddedItem: ITreeViewItem) => {
                      if (JSON.stringify(alreadyAddedItem) === JSON.stringify(item)) {
                        addedAlready = true;
                      }
                    });
                    if (!addedAlready) {
                      uniqueItems.push(item);
                    }
                  });
                  this.props.onChange(uniqueItems);
                });
              }}
              items={this.state.availableCategoriesForComponent}
              isIE={this.props.isIE}
              useColors={this.props.useColors}
            />
          </div>
        </div>
      </div>
    );
  }
}